import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Layout } from 'antd';
import clsx from 'clsx';

import Logo, { LogoColor } from 'components/Logo/Logo';

import { useAuthContext } from 'contexts/AuthContext';
import { useCalculetteModal } from 'contexts/CalculetteModalContext';

import { AccountPopover } from 'layouts/Component/AccountPopover';
import { prefetchCalculettePrime } from 'layouts/Component/CalculetteModalHost';
import { ContactPopover } from 'layouts/Component/ContactPopover';

const { Header } = Layout;

interface AppHeaderProps {
  onLogout: () => void;
  isImpersonated: boolean;
}

export const AppHeader: React.FC<AppHeaderProps> = (props) => {
  const { onLogout, isImpersonated } = props;
  const { t } = useTranslation();
  const { isLeadOnly } = useAuthContext();
  const { openCalculette } = useCalculetteModal();

  return (
    <Header
      className={clsx('print:hidden flex', {
        'top-[52px]': isImpersonated,
      })}
      style={{
        alignItems: 'center',
        position: 'fixed',
        width: '100%',
        zIndex: 1000,
        paddingInline: 16,
      }}
    >
      <Flex align="center" justify="space-between" className="w-full">
        <Logo color={LogoColor.Blue} />
        <Flex align="center" gap={12}>
          <ContactPopover />
          {!isLeadOnly && (
            <Button
              type="primary"
              size="large"
              onClick={openCalculette}
              onMouseEnter={prefetchCalculettePrime}
              onFocus={prefetchCalculettePrime}
            >
              {t('navigation:cta_simulation')}
            </Button>
          )}
          <AccountPopover onLogout={onLogout} />
        </Flex>
      </Flex>
    </Header>
  );
};

export default AppHeader;
